import React, { Component } from 'react';
import { SearchResponse, SearchRequest } from '../../rpc/admin/search_pb';
import Adapter from './adapter';

interface PaginationProps {
    adapter: Adapter;
    response: SearchResponse;
    request: SearchRequest;
}

interface PaginationState { }

class Pagination extends Component<PaginationProps, PaginationState> {

    onChangePage(page: number) {
        this.props.adapter.setOffset(this.props.request!.getLimit() * (page - 1));
    }

    render() {
        if (!this.props.response?.getTotal()) {
            return <></>;
        }

        // https://gist.github.com/kottenator/9d936eb3e4e3c3e02598
        const pageCount = Math.ceil(this.props.response.getTotal() / this.props.request!.getLimit());
        const currentPage = Math.floor(this.props.request!.getOffset() / this.props.request!.getLimit()) + 1;

        const delta = 2;
        const left = currentPage - delta;
        const right = currentPage + delta + 1;
        const range: number[] = [];
        const rangeWithDots: JSX.Element[] = [];
        let l: number = 0;

        for (let i = 1; i <= pageCount; i++) {
            if (i === 1 || i === pageCount || (i >= left && i < right)) {
                range.push(i);
            }
        }

        let index = 0;
        for (let i of range) {
            if (l) {
                if (i - l === 2) {
                    const pageNumber = l + 1;
                    rangeWithDots.push(                                                                                                                                                                                                                                                                                                                                             
                        <button className="button"
                            onClick={() => this.onChangePage(pageNumber)}                                                                                                                                     
                            key={"pagination-" + (index++)}>{l + 1}</button>);
                } else if (i - l !== 1) {
                    rangeWithDots.push(
                        <button className="button ellipsis"
                            disabled
                            key={"pagination-" + (index++)}>...</button>);
                }
            }
            rangeWithDots.push(
                <button disabled={i === currentPage}
                    key={"pagination-" + (index++)}
                    className={"button" + (i === currentPage ? " current" : "")}
                    onClick={() => this.onChangePage(i)}>{i}</button>);
            l = i;
        }

        return (
            <div className="search-pagination">
                {rangeWithDots}
            </div>
        );
    }
}

export default Pagination;